var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 58,
    viewBox: "0 0 56 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3337 42.4999C15.3337 49.4954 21.0047 55.1666 28.0003 55.1666C34.9958 55.1666 40.667 49.4954 40.667 42.4999V26.6666M15.3337 42.4999C8.33805 42.4999 2.66699 36.8287 2.66699 29.8332C2.66699 24.5866 5.93974 20.1172 10.5837 18.3021M15.3337 42.4999V26.6666M40.667 26.6666C47.6625 26.6666 53.3337 20.9955 53.3337 13.9999C53.3337 8.75322 50.0609 4.28388 45.417 2.46875M40.667 26.6666V13.9999M28.0003 4.49991C21.0047 4.49991 15.3337 10.171 15.3337 17.1666C15.3337 20.3332 16.917 23.4999 20.0837 25.0832M28.0003 4.49991C34.9958 4.49991 40.667 10.171 40.667 17.1666C40.667 20.3332 39.0837 23.4999 35.917 25.0832M28.0003 4.49991V13.9999",
    stroke: "#F59E0B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartIcon);
export default __webpack_public_path__ + "static/media/smart-icon.c63706ee8aca11782e1fe357978bffa6.svg";
export { ForwardRef as ReactComponent };